import _objectSpread from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __default__ = {
  name: "Header",
  computed: _objectSpread({}, mapState(["school", "isLoggedIn", "studentAddress", "me", "version", "capabilities"]))
};
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import { mapState } from "vuex";
import { logout } from "@/services/auth";
import RowItem from "../RowItem";
import { useStore } from "vue2-helpers/vuex";
import { formatPhoneNumber } from "@/services/common";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _storeToRefs = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs.schoolPlan;

    var showMenuOne = ref(false);
    var showMenuTwo = ref(false);
    var store = useStore();
    var phoneAttendance = computed(function () {
      return formatPhoneNumber(store.state.school.phone_attendance);
    });
    var phoneMessage = computed(function () {
      return formatPhoneNumber(store.state.school.phone_message);
    });

    var hideMenuTwo = function hideMenuTwo() {
      if (showMenuTwo.value) {
        showMenuTwo.value = false;
      }
    };

    expose({
      schoolPlan: schoolPlan
    });
    return {
      __sfc: true,
      schoolPlan: schoolPlan,
      showMenuOne: showMenuOne,
      showMenuTwo: showMenuTwo,
      store: store,
      phoneAttendance: phoneAttendance,
      phoneMessage: phoneMessage,
      hideMenuTwo: hideMenuTwo,
      logout: logout,
      RowItem: RowItem
    };
  }
});